import script from "./VensoInvoiceRequestOrderItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./VensoInvoiceRequestOrderItem.vue?vue&type=script&setup=true&lang=ts"

import "./VensoInvoiceRequestOrderItem.vue?vue&type=style&index=0&id=4046833f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4046833f"]])

export default __exports__